











































import { defineComponent, onMounted, ref, toRef, watch } from "@vue/composition-api";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "TippingView",
  components: { BaseAvatar, BaseConfirm, BaseInput, BaseIcon, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    value: { type: String, required: true },
    processing: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    currencySymbol: { type: String, required: true },
  },
  setup(props, { emit }) {
    const showModal = ref(false);

    const hideModal = () => {
      showModal.value = false;
      emit("close");
    };

    watch(toRef(props, "show"), () => (showModal.value = props.show));

    onMounted(() => (showModal.value = props.show));

    return {
      showModal,
      hideModal,
    };
  },
});
